import { Stack, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { LanguageContext } from '../../../../../../../../../libs/Context';

const CountDown = ({ targetDate }) =>
{
	const { language } = useContext(LanguageContext);
	const interval = useRef<any>(null);
	const [ time, setTime ] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

	function updateCountdown()
	{
		const now = new Date().valueOf();
		const timeRemaining = new Date(targetDate).valueOf() - now;

		if (timeRemaining <= 0)
		{
			clearInterval(interval.current);

			return;
		}

		const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
		const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

		setTime({ days, hours, minutes, seconds });
	}

	// Update the countdown every second
	useEffect(() =>
	{
		interval.current = setInterval(updateCountdown, 1000);

		return () =>
		{
			clearInterval(interval.current);
		};
	}, []);

	return (
		<Stack direction={'row'} mt={1} border={'1px solid rgba(49, 49, 49, 1)'} borderRadius={'6px'} spacing={4} padding={'4px 12px'}>
			<Stack direction={'column'} alignItems={'center'}>
				<Typography variant='h6'>{time.days}</Typography>
				<Typography fontSize={'var(--pixel12)'}>{language.days}</Typography>
			</Stack>
			<Stack direction={'column'} alignItems={'center'}>
				<Typography variant='h6'>{time.hours}</Typography>
				<Typography fontSize={'var(--pixel12)'}>{language.hours}</Typography>
			</Stack>
			<Stack direction={'column'} alignItems={'center'}>
				<Typography variant='h6'>{time.minutes}</Typography>
				<Typography fontSize={'var(--pixel12)'}>{language.sminutes}</Typography>
			</Stack>
			<Stack direction={'column'} alignItems={'center'}>
				<Typography variant='h6'>{time.seconds}</Typography>
				<Typography fontSize={'var(--pixel12)'}>{language.secondsFull}</Typography>
			</Stack>
		</Stack>
	);
};

export default CountDown;